import React from "react";
import photo from "../assets/images/Olivier.png";

const HomeView = () => {
    return(
        <>
            <div className="title-container">
                <div className="title">
                    <div className="title-fade"></div>
                    <div className="title-outline"></div>
                    <h1>Services spécialisés dans les Hauts-de-France</h1>
                </div>
                <div className="title-gradient"></div>
            </div>
            <div className="content">
                <img src={photo} alt="Olivier Bigord" className="photo" />
                <div className="text-container">
                    <h3>Présentation d'Olivier Bigord - BIGORD PLOMBERIE SERVICES</h3>
                    <p>
                        Depuis 2016, La société <strong><b>BIGORD PLOMBERIE SERVICES</b></strong> est le <strong>partenaire de confiance</strong> pour tous vos travaux de <strong><b>plomberie, chauffage, climatisation et ventilation en région Hauts-de-France</b></strong>. Dirigée par <strong><b>Olivier Bigord</b></strong>, un artisan plombier chauffagiste passionné et expérimenté, l’entreprise met son savoir-faire au service des particuliers, des professionnels, ainsi que des grandes entreprises.
                        <br />
                        <br />
                        Fort de <strong><b>9 ans d’expérience</b></strong> et titulaire d'un CAP Plombier, Olivier a su se forger une solide expertise dans l’installation d'eau, de gaz, de chauffage, de climatisation, de ventilation mécanique contrôlée (VMC) et dans la rénovation des installations existantes. Grâce à ses <strong>certifications RGE et Qualibat</strong>, il vous garantit un travail de haute qualité, respectueux des normes en vigueur et un service qui respecte l'environnement.
                        <br />
                        <br />
                        La réparation, l'installation, l'entretien et le dépannage en urgence font partie des services proposés, avec un engagement fort pour <strong><b>le respect des délais et une qualité irréprochable</b></strong>. Olivier veille à ce que chaque intervention soit réalisée dans les meilleures conditions, en prenant soin d’offrir une attention particulière à la relation client et à la fidélité. Son approche est simple : <strong><b>chaque client mérite une solution adaptée, professionnelle et pérenne</b></strong>.
                        <br />
                        <br />
                        De plus, l’artisan privilégie l’autonomie dans ses projets et apprécie la possibilité de rendre service, tout en veillant à perfectionner constamment ses techniques pour satisfaire pleinement ses clients.
                    </p>
                </div>
            </div>
        </>
    );
};

export default HomeView;